import { withInstall } from '../../utils';
import SplitPane from './src/split-pane.vue';

export const ISplitPane = withInstall(SplitPane); // 增加类型

export default ISplitPane;
